import apiUrls from '../../youwell-common/apiUrls';
import ReduxStoreHelper from '../../youwell-common/ReduxStoreHelper';
import {
    USER_ACTION_PREFIX as ACTION_PREFIX, PROGRAM_TASKRESPONSE_INSERTED, SENSOR_DELETED, SUCCESS_UPLOAD_PROFILEIMAGE, USER_DELETE_PROFILEIMAGE,
} from './actions';

import { notificationKeys, patientProgramElementGroups } from '../../common/constants';
import { sortByDate } from '../../youwell-common/arrayUtils';

const MESSAGE_LIST_UPDATE_RECIEVED = 'MESSAGE_LIST_UPDATE_RECIEVED';
const MESSAGES_READ_RECIEVED = 'MESSAGES_READ_RECIEVED';
const USER_STATE_RECIEVED = 'USER_STATE_RECIEVED';
const ACTIVITY_INSERTED = 'ACTIVITY_INSERTED';
const USER_DELETED = 'USER_DELETED';

const storeHelper = new ReduxStoreHelper(ACTION_PREFIX);

export const actionCreators = {
    checkForNewMessages: storeHelper.createGetListActionCreator(`${apiUrls.app.message}`, MESSAGE_LIST_UPDATE_RECIEVED),
    insertMessage: storeHelper.createInsertActionCreator(`${apiUrls.app.message}`, MESSAGE_LIST_UPDATE_RECIEVED),
    getUserState: options => (dispatch, getState) => {
        storeHelper.fetch(dispatch, {
            url: `${apiUrls.app.user}/state/${getState().user.userStateTimeStamp || ''}`,
            onData: (data) => {
                dispatch({ type: `${ACTION_PREFIX}/${USER_STATE_RECIEVED}`, data });
            },
            options: { background: true, ...options },
        });
    },
    markMessagesAsRead: (timestamp, options) => (dispatch) => {
        storeHelper.fetch(dispatch, {
            url: `${apiUrls.app.message}/read/${timestamp}`,
            method: 'PUT',
            completeAction: `${ACTION_PREFIX}/${MESSAGES_READ_RECIEVED}`,
            options,
        });
    },
    sendActivity: (activity, options) => (dispatch) => {
        storeHelper.fetch(dispatch, {
            url: `${apiUrls.app.user}/act`,
            method: 'POST',
            body: activity,
            completeAction: `${ACTION_PREFIX}/${ACTIVITY_INSERTED}`,
            options: { background: true, ...options },
        });
    },
    removeSensor: storeHelper.createDeleteActionCreator(`${apiUrls.app.sensor}`, SENSOR_DELETED),
    deleteUser: storeHelper.createDeleteActionCreator(`${apiUrls.app.user}`, USER_DELETED),
    saveProfilePicture: storeHelper.createFileUploadActionCreator(`${apiUrls.app.user}/image`, SUCCESS_UPLOAD_PROFILEIMAGE),
    deleteProfilePicture: options => (dispatch) => {
        storeHelper.fetch(dispatch, {
            url: `${apiUrls.app.user}/image`,
            method: 'DELETE',
            completeAction: USER_DELETE_PROFILEIMAGE,
            options,
        });
    },
};

const initialState = {
    ...storeHelper.defaultInitialState,
    sessionId: null,
    userStateTimeStamp: null,
    messageList: null,
    notifications: [],
    activityId: null,
    unreadMessages: 0,
    allMessagesFetched: false,
};


const setNotifications = (userState, currentNotifications) => {
    const notifications = [...currentNotifications];

    if (!userState) {
        return notifications;
    }

    if (userState.unreadMessages > 0) {
        notifications.push(notificationKeys.unreadMessages);
    }
    if (userState.overdueTasks && userState.overdueTasks.length > 0) {
        notifications.push(...userState.overdueTasks.map(p => `${notificationKeys.program}_${p}_${notificationKeys.overdueTasks}`));
    }
    return notifications;
};

export const reducer = (state, action) => {
    const stateFromDefaultActions = storeHelper.defaultReducer(state, action, initialState);

    if (stateFromDefaultActions !== null) {
        return stateFromDefaultActions;
    }

    switch (action.type) {
    case `${ACTION_PREFIX}/${MESSAGE_LIST_UPDATE_RECIEVED}`: {
        const messageList = sortByDate(state.messageList ? [...state.messageList, ...action.data] : action.data) || [];
        const messagesTimestamp = messageList[0]?.created;

        return {
            ...state,
            messageList,
            messagesTimestamp,
            allMessagesFetched: action.requestParams?.count ? (action.data.length < action.requestParams.count) : state.allMessagesFetched,
        };
    }

    case `${ACTION_PREFIX}/${USER_STATE_RECIEVED}`: {
        return {
            ...state,
            sessionId: action.data.sid,
            unreadMessages: action.data.unreadMessages,
            userStateTimeStamp: action.data.timeStamp,
            notifications: setNotifications(action.data, state.notifications),
        };
    }
    case PROGRAM_TASKRESPONSE_INSERTED: {
        return {
            ...state,
            // todo - check for real..!
            notifications: action.reducerParams && action.reducerParams.group === patientProgramElementGroups.scheduled
                ? state.notifications.filter(d => d !== `${notificationKeys.program}_${action.reducerParams.patientProgramId}_${notificationKeys.overdueTasks}`)
                : [...state.notifications],
        };
    }
    case `${ACTION_PREFIX}/${MESSAGES_READ_RECIEVED}`: {
        return {
            ...state,
            unreadMessages: 0,
            notifications: state.notifications.filter(d => d !== notificationKeys.unreadMessages),
            messageList: state.messageList.map(m => (
                m.created < action.reducerParams.timestamp ? m : { ...m, patientReadTime: action.reducerParams.timestamp }
            )),
        };
    }
    case `${ACTION_PREFIX}/${ACTIVITY_INSERTED}`: {
        return {
            ...state,
            activityId: action.data,
        };
    }
    default: {
        return state || initialState;
    }
    }
};
